/**
 * Auth0 Configuration
 *
 * Environment variables required:
 * - VITE_AUTH0_DOMAIN: Your Auth0 tenant domain (e.g., "your-tenant.auth0.com")
 * - VITE_AUTH0_CLIENT_ID: Your Auth0 application client ID
 * - VITE_AUTH0_AUDIENCE: Your Auth0 API identifier/audience
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
    scope: 'openid profile email',
  },
  // Cache tokens in localStorage to persist across page refreshes
  // For internal apps with domain-gated access, this is a reasonable security tradeoff
  cacheLocation: 'localstorage' as const,
  // Use refresh tokens for longer sessions
  useRefreshTokens: true,
};

// Validate configuration
export const isAuth0Configured = (): boolean => {
  return !!(
    auth0Config.domain &&
    auth0Config.clientId &&
    auth0Config.authorizationParams.audience
  );
};

// Log configuration status (without exposing sensitive values)
if (import.meta.env.DEV) {
  console.log('Auth0 Configuration Status:', {
    domain: auth0Config.domain ? 'Set' : 'Missing',
    clientId: auth0Config.clientId ? 'Set' : 'Missing',
    audience: auth0Config.authorizationParams.audience ? 'Set' : 'Missing',
    isConfigured: isAuth0Configured(),
  });
}
